// extracted by mini-css-extract-plugin
module.exports = {"checkout_container":"Success_checkout_container__2udb6","title":"Success_title__cgMVS","info":"Success_info__4SoCS"};